import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
interface PricingGridProps {
  selectedPack: number;
  setSelectedPack: (pack: number) => void;
  packLinks: string[];
}
export function PricingGrid({
  selectedPack,
  setSelectedPack,
  packLinks
}: PricingGridProps) {
  return <div className="w-full" data-id="element-4">
      <div className="flex flex-col gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-5">
        {/* Pack 0: Mega Pack */}
        <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-3 md:p-4 transition-all duration-200 cursor-pointer backdrop-blur-sm w-full ${selectedPack === 0 ? 'bg-[#0d1530]/95 border-2 border-[#16a34a] shadow-[0_0_20px_rgba(22,163,74,0.4)]' : 'bg-[#0d1530]/70 border-2 border-[#16a34a]/30 shadow-[0_0_8px_rgba(22,163,74,0.1)] hover:border-[#16a34a]/50'}`} data-id="element-6">
          <div className={`absolute top-3 right-3 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#16a34a] bg-[#16a34a]' : 'border-gray-500'}`} data-id="element-7">
            {selectedPack === 0 && <CheckIcon className="w-3 h-3 text-black font-black" data-id="element-8" />}
          </div>
          <div className="flex items-start gap-3" data-id="element-9">
            <div className="text-2xl md:text-3xl mt-1" data-id="element-10">📦</div>
            <div className="flex-1" data-id="element-11">
              <h3 className="text-sm md:text-base font-black text-white mb-1 uppercase leading-tight pr-6" data-id="element-12">
                MEGA PACK MAESTRO CERRAJERO
              </h3>
              <p className="text-[10px] md:text-xs text-gray-300 mb-1.5 font-bold leading-snug" data-id="element-13">
                ✔ PDF + Videos ✔ Técnicas paso a paso ✔ Acceso inmediato ✔
                Bonus incluidos
              </p>
              <p className="text-[10px] md:text-xs text-[#4ade80] font-black uppercase tracking-wider mb-2" data-id="element-14">
                👉 Ideal para empezar desde cero
              </p>
              <div className="flex items-baseline gap-2" data-id="element-15">
                <span className="text-xl md:text-2xl font-black text-white" data-id="element-16">
                  $19.990
                </span>
                <span className="text-gray-500 text-xs md:text-sm line-through font-bold" data-id="element-17">
                  $39.990
                </span>
              </div>
            </div>
          </div>
        </button>

        {/* Pack 1: Mega Pack + Auto */}
        <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-3 md:p-4 transition-all duration-200 cursor-pointer backdrop-blur-sm w-full ${selectedPack === 1 ? 'bg-[#0d1530]/95 border-2 border-[#16a34a] shadow-[0_0_20px_rgba(22,163,74,0.4)]' : 'bg-[#0d1530]/70 border-2 border-[#16a34a]/30 shadow-[0_0_8px_rgba(22,163,74,0.1)] hover:border-[#16a34a]/50'}`} data-id="element-18">
          <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#16a34a] text-black text-[9px] md:text-[11px] font-black px-3 py-0.5 rounded-full uppercase tracking-widest whitespace-nowrap shadow-[0_0_15px_rgba(22,163,74,0.5)]" data-id="element-19">
            ⭐ MÁS ELEGIDO
          </span>
          <div className={`absolute top-3 right-3 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#16a34a] bg-[#16a34a]' : 'border-gray-500'}`} data-id="element-20">
            {selectedPack === 1 && <CheckIcon className="w-3 h-3 text-black font-black" data-id="element-21" />}
          </div>
          <div className="flex items-start gap-3" data-id="element-22">
            <div className="text-2xl md:text-3xl mt-1" data-id="element-23">🚀</div>
            <div className="flex-1" data-id="element-24">
              <h3 className="text-sm md:text-base font-black text-white mb-1 uppercase leading-tight pr-6" data-id="element-25">
                MEGA PACK MAESTRO CERRAJERO + KIT COMPLETO CERRAJERÍA DEL
                AUTOMOTOR
              </h3>
              <p className="text-[10px] md:text-xs text-gray-300 font-bold mb-1" data-id="element-26">
                ✔ Todo lo anterior +
              </p>
              <p className="text-[11px] md:text-xs text-[#4ade80] font-black uppercase mb-1.5" data-id="element-27">
                🚗 Módulo completo de cerrajería automotor
              </p>
              <ul className="space-y-0.5 mb-2" data-id="element-28">
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs leading-tight font-medium" data-id="element-29">
                  <CheckIcon className="w-3 h-3 text-[#16a34a] flex-shrink-0 mt-0.5" data-id="element-30" />
                  Clonación de llaves, Programación, Transponder, Sistemas
                  electrónicos
                </li>
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs leading-tight font-medium" data-id="element-31">
                  <CheckIcon className="w-3 h-3 text-[#16a34a] flex-shrink-0 mt-0.5" data-id="element-32" />
                  Trabajos más avanzados y mejor pagos
                </li>
              </ul>
              <div className="bg-green-900/30 border border-green-500/30 rounded p-1.5 mb-2" data-id="element-33">
                <p className="text-[9px] md:text-[10px] text-green-300 font-bold text-center uppercase tracking-wider" data-id="element-34">
                  Por solo $10.000 más accedés a una formación mucho más
                  completa y con mayor potencial de ingresos
                </p>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-35">
                <span className="text-xl md:text-2xl font-black text-white" data-id="element-36">
                  $29.990
                </span>
                <span className="text-gray-500 text-xs md:text-sm line-through font-bold" data-id="element-37">
                  $49.990
                </span>
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* CTA Button */}
      <div className="text-center" data-id="element-38">
        <a href={packLinks[selectedPack]} className="cta-pulse inline-flex items-center justify-center gap-2 w-full bg-[#16a34a] hover:bg-[#15803d] text-black font-black text-base md:text-xl py-3 px-6 md:py-4 md:px-10 rounded-xl transition-all duration-200 uppercase tracking-wide shadow-[0_0_20px_rgba(22,163,74,0.4)]" data-id="element-39">
          👉 QUIERO ACCEDER AHORA
        </a>
        <p className="text-gray-300 text-[10px] md:text-xs font-black mt-2 flex items-center justify-center gap-1.5 uppercase tracking-widest" data-id="element-40">
          <LockIcon className="w-3.5 h-3.5 text-[#16a34a]" data-id="element-41" /> PAGO SEGURO ·
          ACCESO INMEDIATO
        </p>
        <p className="text-gray-500 text-[9px] md:text-[10px] font-bold mt-1 uppercase tracking-widest" data-id="element-42">
          Mercado Pago · Tarjeta · Transferencia
        </p>
      </div>
    </div>;
}